.wrapper {
  flex-direction: column;
  .empty-view {
    color: var(--body-text-arrows-400);
    padding: 0 calc(var(--spacer) * 4.2);
  }
}

#tactics {
  display: flex;
  flex-direction: column;
  margin-top: calc(var(--spacer) * 2);

  gz-labeled-content {
    flex: 1;
    --padding-content-label: calc(var(--spacer) / 4) 0 0 0;
  }

  gz-link {
    --font-family: var(--font-family-secondary);
    font-weight: 400;
  }

  .technique-container {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: calc(var(--spacer) * 1.5);

    gz-tooltip {
      overflow: hidden;

      .technique-name {
        width: auto;
        padding-left: var(--spacer);
        color: var(--body-text-arrows-400);
        font-weight: normal;
        font-size: var(--body-size);
        text-overflow: ellipsis;
        overflow: hidden;
        font-family: var(--font-family-secondary);
      }
    }
  }

  gz-labeled-content > .technique-container:last-child {
    margin-bottom: calc(var(--spacer) / 2);
  }
}
